<template>
  <div id="app">
    <div id="demo"></div>
  </div>
</template>

<script>
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
  data() {
    return {
      pdfh5: null,
    };
  },
  mounted() {
    this.pdfh5 = new Pdfh5("#demo", {
      data:atob(this.$route.params.src)
    });
  },
};
</script>

<style lang="scss" scoped>
 #demo{
     width: 100%;
     height: 100vh;
 }
</style>